import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import {
  useLazyPaymentDetailQuery,
  usePaymentStatusMutation,
} from "../../service/payments";
import { CommonBody, PaymentResponseType } from "../../types/General";
import { errorToast } from "../../helpers";
import PaymentDetailTop from "../../features/payments/PaymentTopDetail";
import Loader from "../../constants/Loader";
import moment from "moment";
import { PAYMENT_STATUS_LABELS } from "../../utils/enums";
import { PriceFormatter } from "../../utils/commoFunctions";
import { generateEncryptedKeyBody } from "../../utils/crypto";

const PaymentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [getPaymentById] = useLazyPaymentDetailQuery();
  const [paymentStatus] = usePaymentStatusMutation();

  const [paymentDetail, setPaymentDetail] =
    useState<PaymentResponseType | null>(null);

  const getDetails = async (id: number) => {
    setLoading(true);

    try {
      const response = await getPaymentById({
        id,
      }).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        setPaymentDetail(response?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const changePaymentStatus = async (id: number) => {
    setLoading(true);
    try {
      const body = {
        is_verified: true,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await paymentStatus({
        body: encryptedBody,
        id,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        getDetails(id);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getDetails(Number(id));
    }
  }, [id]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>Payment Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-payments/payment-modes")}>
              Manage Payments
            </span>{" "}
            - Payment Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>
      <PaymentDetailTop
        type="individual"
        data={paymentDetail}
        changePaymentStatus={changePaymentStatus}
      />
      <div className="cards" style={{ marginTop: "20px" }}>
        <div className="profileInfo_list">
          <ul className="text_info gap_p">
            <li className="w_50">
              <strong>Payment Date</strong>
              <span>
                {paymentDetail?.created_at
                  ? moment(paymentDetail?.created_at)?.format(
                      "DD MMM YYYY hh:mm a"
                    )
                  : "-"}
              </span>
            </li>

            <li className="w_50">
              <strong>{"E-mail"}</strong>
              <span>{paymentDetail?.user?.email || "-"}</span>
            </li>

            <li className="w_50">
              <strong>Payment Mode</strong>
              <span>{paymentDetail?.plan_mode?.title || "-"}</span>
            </li>
            <li className="w_50">
              <strong>Payment Type</strong>
              <span>
                {paymentDetail?.plan_part_no?.part_number !== null &&
                paymentDetail?.plan_part_no?.part_number !== undefined
                  ? PAYMENT_STATUS_LABELS[
                      paymentDetail?.plan_part_no?.part_number
                    ]
                  : "-"}
              </span>
            </li>
            <li className="w_50">
              <strong>Amount Paid</strong>
              <span>
                {paymentDetail?.payment_amt
                  ? PriceFormatter(paymentDetail?.payment_amt?.toString())
                  : "-"}
              </span>
            </li>

            {paymentDetail?.payment_status === 0 ? (
              <li className="w_50">
                <strong>Remaining First Payment</strong>
                <span>
                  {" "}
                  {paymentDetail?.remaining_amt
                    ? PriceFormatter(paymentDetail?.remaining_amt?.toString())
                    : "-"}
                </span>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </MainContainer>
  );
};

export default PaymentDetail;
